import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { SessionService } from '@app-store/session/session.service';

@Injectable({
	providedIn: 'root'
})
export class SessionGuard  {
	constructor(private router: Router, private sessionService: SessionService) {}

	canLoad() {
		return this.validate();
	}

	private validate() {
		return this.sessionService.isAuthenticated().pipe(
			take(1),
			switchMap(isLoggedIn => {
				if (!isLoggedIn) {
					this.router.navigateByUrl('/login');
				}
				return of(isLoggedIn);
			})
		);
	}
}
